// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fedb5d47fa5b6b44c19ffc44b15e78aaad04c130.chunk.js";
};